import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CInputGroup,
  CModal,
  CSwitch,
  CLink
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

// import socketIOClient from "socket.io-client";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import HelpdeskCategoryModal from "../../../../components/HelpdeskCategoryModal";
import Interface from "../../../../components/Interface";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import QuestionViewerModal from "../../../../components/QuestionViewerModal";
import { Input, Text } from "../../../../components/SlateComponents";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class Helpdesk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selected: null,
      inputText: [{ type: "paragraph", children: [{ text: "" }] }],
      pageId: null,
      objId: null,
      listId: null,
      questionId: null,
      questionModal: null,
      interfaceModal: null,
      categoryModal: false,
      pictureModal: false
    };

    this.overflowDiv = React.createRef();
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ loading: true });

    this.select(this.props.match.params.id);
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  select(id, shouldReload = true) {
    this.setState({
      loading: shouldReload,
      inputText: [{ type: "paragraph", children: [{ text: "" }] }]
    });

    axios
      .post(`${URL.api}helpdesk/helpdesk/singleView/${id}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ selected: resp.data.data, loading: false }, () => {
          setTimeout(
            () =>
              this.overflowDiv.current?.scrollIntoView({
                behavior: "smooth",
                block: "end"
              }),
            200
          );
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        this.error("Não foi possível carregar a solicitação");
      });
  }

  changeStatus(open) {
    const previousStatus = this.state.selected.status;

    this.setState(state => ({
      selected: { ...state.selected, status: open ? "ABERTO" : "FECHADO" }
    }));

    axios
      .post(
        `${URL.api}helpdesk/helpdesk/update/${this.state.selected.id}`,
        { status: open ? "ABERTO" : "FECHADO" },
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {})
      .catch(error => {
        this.setState(state => ({
          selected: { ...state.selected, status: previousStatus }
        }));
        this.error("Não foi possível alterar o status da solicitação");
      });
  }

  sendMessage() {
    const obj = {
      description: JSON.stringify(this.state.inputText),
      type_id: this.state.selected.type_id,
      obj_id: this.state.selected.obj_id,
      user_id: this.props.user.user.id,
      category_id: this.state.selected.category_id,
      status: this.state.selected.status,
      helpdesk_id: this.state.selected.id
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.select(this.state.selected.id, false);
      })
      .catch(error => {
        this.error("Não foi possível enviar a mensagem");
      });
  }

  sendNewMessage() {
    const obj = {
      description: JSON.stringify(this.state.inputText),
      user_id: this.props.user.user.id,
      category_id: this.state.createCategory,
      status: "ABERTO"
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.select(resp.data.data, true);
        this.reloadHelpdesks();
      })
      .catch(error => {
        this.error("Não foi possível criar a solicitação");
      });
  }

  openContent(helpdesk) {
    switch (helpdesk.type_id) {
      case 1:
        axios
          .get(`${URL.api}content/los/listLosChildren/${helpdesk.obj_id}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            for (let i = 0; i < resp.data.data.length; i++) {
              if (resp.data.data[i].son_id === helpdesk.additional_obj_id) {
                this.setState({
                  pageId: resp.data.data[i].order,
                  objId: helpdesk.obj_id,
                  interfaceModal: true
                });
              }
            }
          });

        break;
      case 25:
        this.setState({
          listId: helpdesk.additional_obj_id,
          questionId: helpdesk.obj_id,
          questionModal: true
        });
        break;
      default:
        this.setState({
          objId: helpdesk.obj_id,
          pageId: null,
          interfaceModal: true
        });
        break;
    }
  }

  // openContent(helpdesk) {
  //   if (helpdesk.type_id === 1) {
  //     axios
  //       .get(`${URL.api}content/los/listLosChildren/${helpdesk.obj_id}`, {
  //         headers: { authorization: `Bearer ${this.props.user.token}` }
  //       })
  //       .then(resp => {
  //         let array = resp.data.data;

  //         for (let i = 0; i < 3; i++) {
  //           // if (resp.data.data[i].son_id === helpdesk.additional_obj_id) {
  //           //   this.setState({
  //           //     pageId: resp.data.data[i].order,
  //           //     objId: helpdesk.obj_id,
  //           //     interfaceModal: true
  //           //   });
  //           // }
  //         }
  //       });
  //   } else if (helpdesk.type_id === 25) {
  //     this.setState({
  //       listId: helpdesk.additional_obj_id,
  //       questionId: helpdesk.obj_id,
  //       questionModal: true
  //     });
  //   } else {
  //     this.setState({
  //       objId: helpdesk.obj_id,
  //       pageId: null,
  //       interfaceModal: true
  //     });
  //   }
  // }

  render() {
    return (
      <>
        {this.state.pictureModal && (
          <CModal
            show={this.state.pictureModal}
            // onOpened={() => this.createLog()}
            onClose={
              (this.props.onClose,
              () => {
                this.setState({ pictureModal: false });
              })
            }
            size="lg w-100 h-100 m-0 p-2 mw-100"
            style={{ width: "100%", height: "100%" }}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton>
              <CModalTitle>
                <span className="font-weight-bold">URL: </span>
                <CLink
                  href={this.state.selected.link}
                  style={{ color: "inherit" }}
                >
                  {this.state.selected.link}
                </CLink>
              </CModalTitle>
            </CModalHeader>
            <CModalBody style={{ overflow: "auto" }}>
              <div>
                <img
                  alt=""
                  src={URL.img + this.state.selected.screenshot}
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    borderRadius: "0.25rem"
                  }}
                />
              </div>
            </CModalBody>
          </CModal>
        )}
        {this.state.interfaceModal && (
          <Interface
            show={this.state.interfaceModal}
            title="Visualizador de conteúdo"
            onClose={() => this.setState({ interfaceModal: false })}
            aula={this.state.objId}
            pagina={this.state.pageId}
            currentRoute={this.props.currentRoute}
          />
        )}
        {this.state.questionModal && (
          <QuestionViewerModal
            show={this.state.questionModal}
            onClose={() => this.setState({ questionModal: false })}
            question={this.state.questionId}
            list={this.state.listId}
          />
        )}
        {this.state.categoryModal && (
          <HelpdeskCategoryModal
            show={this.state.categoryModal}
            onClose={() =>
              this.setState({ categoryModal: false }, () =>
                this.select(this.props.match.params.id, false)
              )
            }
            helpdesk={this.props.match.params.id}
            category={this.state.selected.category_id}
          />
        )}
        <div className="row m-0" style={{ flex: 1 }}>
          <div className="col p-0">
            <Breadcrumb
              current={this.props.currentRoute}
              items={[{ path: "/helpdesk", to: "/helpdesk" }]}
            />
            <CCard style={{ height: "calc(98vh - 106px - 4rem)" }}>
              {!this.state.loading ? (
                <>
                  <CCardHeader className="d-flex align-items-center w-100">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1
                      }}
                    >
                      <h4 className="card-title mb-1">
                        <i
                          className="fa fa-angle-left mr-3 font-weight-bold cursor"
                          onClick={() => this.props.history.goBack()}
                        ></i>
                        Ticket #{this.state.selected.id}
                        <span
                          className="small helpdesk-category-edit ml-1"
                          style={{ opacity: 0.6 }}
                          onClick={() => this.setState({ categoryModal: true })}
                        >
                          {this.state.selected.category_name}
                        </span>
                      </h4>
                      <div className="small text-muted">
                        Veja as mensagens dessa solicitação
                      </div>
                    </div>
                    <span className="text-muted mr-2">Aberto</span>
                    <CSwitch
                      color="primary"
                      shape="pill"
                      size="sm"
                      checked={this.state.selected.status === "ABERTO"}
                      onChange={e => this.changeStatus(e.target.checked)}
                    />
                  </CCardHeader>
                  <CCardBody className="p-0 d-flex flex-column overflow-auto">
                    <div
                      className="d-flex p-3 justify-content-end flex-column"
                      style={{ flex: 1 }}
                      ref={this.overflowDiv}
                    >
                      {(this.state.selected.screenshot ||
                        this.state.selected.link) && (
                        <div
                          className={`pt-3 d-flex justify-content-${
                            this.state.selected.user_id ===
                            this.props.user.user.id
                              ? "end"
                              : "start"
                          }`}
                        >
                          {this.state.selected.user_id !==
                            this.props.user.user.id && (
                            <div
                              className="c-avatar mr-3"
                              style={{ height: "30px", width: "30px" }}
                            >
                              <img
                                src={
                                  URL.img +
                                  (this.state.selected.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                className="c-avatar-img"
                                alt="Usuário"
                              />
                            </div>
                          )}
                          <div
                            className={`p-2 ${
                              this.state.selected.user_id ===
                              this.props.user.user.id
                                ? "bg-primary text-white"
                                : "bg-light text-black"
                            }`}
                            style={{ borderRadius: "0.25rem", maxWidth: "70%" }}
                          >
                            <div
                              style={{
                                fontSize: "small",
                                fontStyle: "italic",
                                opacity: 0.6
                              }}
                              className="mb-2"
                            >
                              <i className="fa fa-cog mr-2"></i>Capturado pelo
                              sistema
                            </div>
                            {/* AQUI */}
                            {this.state.selected.screenshot && (
                              <img
                                alt=""
                                src={URL.img + this.state.selected.screenshot}
                                className="mb-1"
                                id="picture"
                                style={{
                                  display: "block",
                                  maxWidth: "100%",
                                  maxHeight: "20em",
                                  borderRadius: "0.25rem"
                                }}
                                onClick={() => {
                                  this.setState({ pictureModal: true });
                                }}
                              />
                            )}
                            {this.state.selected.link && (
                              <div>
                                <span className="font-weight-bold">URL: </span>
                                <CLink
                                  href={this.state.selected.link}
                                  style={{ color: "inherit" }}
                                >
                                  {this.state.selected.link}
                                </CLink>
                              </div>
                            )}
                            {this.state.selected.type_id !== 16 && (
                              <div>
                                <CButton
                                  className={`${
                                    this.state.selected.user_id ===
                                    this.props.user.user.id
                                      ? "bg-white text-primary"
                                      : "bg-secondary text-dark"
                                  } mt-2`}
                                  onClick={() =>
                                    this.openContent(this.state.selected)
                                  }
                                >
                                  Abrir conteúdo
                                </CButton>
                              </div>
                            )}
                            <div
                              className="d-flex justify-content-end small"
                              style={{ opacity: "75%" }}
                            >
                              {this.friendlyDate(
                                this.state.selected.created_at
                              )}
                            </div>
                          </div>
                          {this.state.selected.user_id ===
                            this.props.user.user.id && (
                            <div
                              className="c-avatar ml-3"
                              style={{ height: "30px", width: "30px" }}
                            >
                              <img
                                src={
                                  URL.img +
                                  (this.state.selected.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                className="c-avatar-img"
                                alt="Usuário"
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div
                        className={`pt-3 d-flex justify-content-${
                          this.state.selected.user_id ===
                          this.props.user.user.id
                            ? "end"
                            : "start"
                        }`}
                      >
                        {this.state.selected.user_id !==
                          this.props.user.user.id && (
                          <div
                            className="c-avatar mr-3"
                            style={{ height: "30px", width: "30px" }}
                          >
                            <img
                              src={
                                URL.img +
                                (this.state.selected.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="c-avatar-img"
                              alt="Usuário"
                            />
                          </div>
                        )}
                        <div
                          className={`p-2 ${
                            this.state.selected.user_id ===
                            this.props.user.user.id
                              ? "bg-primary text-white"
                              : "bg-light text-black"
                          }`}
                          style={{ borderRadius: "0.25rem", maxWidth: "70%" }}
                        >
                          {this.state.selected.user_id !==
                            this.props.user.user.id && (
                            <div className="d-flex small font-weight-bold">
                              {this.state.selected.user_name} -{" "}
                              {this.state.selected.region_name}
                            </div>
                          )}
                          <Text>{this.state.selected.description}</Text>
                          <div
                            className="d-flex justify-content-end small"
                            style={{ opacity: "75%" }}
                          >
                            {this.friendlyDate(this.state.selected.created_at)}
                          </div>
                        </div>
                        {this.state.selected.user_id ===
                          this.props.user.user.id && (
                          <div
                            className="c-avatar ml-3"
                            style={{ height: "30px", width: "30px" }}
                          >
                            <img
                              src={
                                URL.img +
                                (this.state.selected.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="c-avatar-img"
                              alt="Usuário"
                            />
                          </div>
                        )}
                      </div>
                      {this.state.selected.comments
                        .slice(0)
                        .reverse()
                        .map(item => (
                          <div
                            key={item.id}
                            className={`pt-3 d-flex justify-content-${
                              item.user_id === this.props.user.user.id
                                ? "end"
                                : "start"
                            }`}
                          >
                            {item.user_id !== this.props.user.user.id && (
                              <div
                                className="c-avatar mr-3"
                                style={{ height: "30px", width: "30px" }}
                              >
                                <img
                                  src={
                                    URL.img +
                                    (item.user_photo ||
                                      "uploads/users/profileEmpty.jpg")
                                  }
                                  className="c-avatar-img"
                                  alt="Usuário"
                                />
                              </div>
                            )}
                            <div
                              className={`p-2 ${
                                item.user_id === this.props.user.user.id
                                  ? "bg-primary text-white"
                                  : "bg-light text-black"
                              }`}
                              style={{
                                borderRadius: "0.25rem",
                                maxWidth: "70%"
                              }}
                            >
                              {item.user_id !== this.props.user.user.id && (
                                <div className="d-flex small font-weight-bold">
                                  {item.user_name}
                                  {item.user_id ===
                                    this.state.selected.user_id &&
                                    ` - ${this.state.selected.region_name}`}
                                </div>
                              )}
                              <Text>{item.description}</Text>
                              <div
                                className="d-flex justify-content-end small"
                                style={{ opacity: "75%" }}
                              >
                                {this.friendlyDate(item.created_at)}
                              </div>
                            </div>
                            {item.user_id === this.props.user.user.id && (
                              <div
                                className="c-avatar ml-3"
                                style={{ height: "30px", width: "30px" }}
                              >
                                <img
                                  src={
                                    URL.img +
                                    (item.user_photo ||
                                      "uploads/users/profileEmpty.jpg")
                                  }
                                  className="c-avatar-img"
                                  alt="Usuário"
                                />
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </CCardBody>
                  {this.state.selected.status === "ABERTO" ? (
                    <CCardFooter className="flex-column align-items-end">
                      <CInputGroup className="h-100 mb-2">
                        <Input
                          value={this.state.inputText}
                          onChange={value =>
                            this.setState({ inputText: value })
                          }
                          placeholder="Digite uma mensagem"
                        />
                      </CInputGroup>
                      <CButton
                        color="primary"
                        onClick={() => this.sendMessage()}
                      >
                        <i className="fa fa-send"></i>&nbsp; Enviar
                      </CButton>
                    </CCardFooter>
                  ) : (
                    <CCardFooter className="flex-column align-items-center py-5">
                      <span className="text-muted">
                        Para enviar uma mensagem, reabra o ticket
                      </span>
                    </CCardFooter>
                  )}
                </>
              ) : (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted">
                  <div className="p-4">
                    <Loading />
                  </div>
                </CCardBody>
              )}
            </CCard>
          </div>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Helpdesk);
